import React, { useCallback, useEffect, useState } from 'react'
import Header from '../components/Header';
import Footer from '../components/Footer';
import Menu from '../components/Menu';
import axios from 'axios';
import Swal from 'sweetalert2';
const config = require('../config.json')

export default function Profile({ ipAddress, loginData }) {
  const [account] = useState(loginData?.ulid);
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [mobile, setMobile] = useState('');
  const [bname, setBname] = useState('');
  const [ifsc, setifsc] = useState('');
  const [acno, setAcno] = useState('');
  const [upi, setUpi] = useState('');
  const [pan, setPan] = useState('');
  const [address, setaddress] = useState('');
  const [city, setcity] = useState('');
  const [state, setstate] = useState('');
  const [pin, setpin] = useState('');
  const [pani, setpani] = useState('');
  const [addhari, setaddhari] = useState('');
  const [banki, setbanki] = useState('');
  const [pani2, setpani2] = useState('');
  const [addhari2, setaddhari2] = useState('');
  const [banki2, setbanki2] = useState('');
  const [addhar, setaddhar] = useState('');
  const [oldp, setOld] = useState('');
  const [newp, setNew] = useState('');
  const [rnew, setRnew] = useState('');
  const [kyc, setKyc] = useState(true);
  const handleProfile = useCallback(() => {

    let data = JSON.stringify({
      "ip": ipAddress,
      "ulid": loginData.ulid
    });

    let axiosConfig = {
      method: 'post',
      maxBodyLength: Infinity,
      url: `${config.baseUrl}profile`,
      headers: {
        'ip': ipAddress,
        'ulid': loginData.ulid,
        'auth': loginData.auth,
        'token': loginData.token,
        'Content-Type': 'application/json'
      },
      data: data
    };
    // console.log(axiosConfig)
    axios.request(axiosConfig)
      .then((res) => {
        let response = res.data;
        console.log(response)
        setName(response.data?.uname)
        setEmail(response.data?.uemail)
        setMobile(response.data?.umobile)
        setBname(response.data?.bank)
        setifsc(response.data?.ifsc)
        setAcno(response.data?.ac)
        setUpi(response.data?.upi)
        setPan(response.data?.upan)
        setaddhar(response.data?.addhar)
        setaddress(response.data?.address)
        setcity(response.data?.city)
        setstate(response.data?.state)
        setpin(response.data?.pin)
        setpani2(response.data?.upani)
        setaddhari2(response.data?.addhari)
        setbanki2(response.data?.banki)
        setKyc(response.data?.kyc)
      }).catch((error) => {
        console.log(error);
      });
  }, [account, ipAddress, loginData.auth, loginData.token, loginData.ulid])


  useEffect(() => {
    handleProfile()
  }, [handleProfile])

  const handleProfileEdit = (e) => {
    e.preventDefault()
    if (kyc == 0) {
      let data = JSON.stringify({
        "ip": ipAddress,
        "ulid": loginData.ulid,
        "name": name,
        "email": email,
        "mobile": mobile,
        "bank": bname,
        "ifsc": ifsc,
        "ac": acno,
        "upi": upi,
        "pan": pan,
        "pin": pin,
        "address": address,
        "city": city,
        "state": state,
        "addhar": addhar,
        "addhari": addhari,
        "banki": banki,
        "pani": pani
      });

      let axiosConfig = {
        method: 'post',
        maxBodyLength: Infinity,
        url: `${config.baseUrl}profileedit`,
        headers: {
          'ip': ipAddress,
          'ulid': loginData.ulid,
          'auth': loginData.auth,
          'token': loginData.token,
          'Content-Type': 'application/json'
        },
        data: JSON.stringify(data)
      };
      axios.request(axiosConfig)
        .then((res) => {
          let response = res.data;
          console.log(response);
          setName(response.data?.uname)
          setEmail(response.data?.uemail)
          setMobile(response.data?.umobile)
          setBname(response.data?.bank)
          setifsc(response.data?.ifsc)
          setAcno(response.data?.ac)
          setUpi(response.data?.upi)
          setPan(response.data?.upan)
          setaddhar(response.data?.addhar)
          setaddress(response.data?.address)
          setcity(response.data?.city)
          setstate(response.data?.state)
          setpin(response.data?.pin)
          setpani(response.data?.upani)
          setaddhari(response.data?.addhari)
          setbanki(response.data?.banki)
          setKyc(response.data?.kyc)
          Swal.fire('AK Herbal', response?.message, 'info');
        })
        .catch((error) => {
          console.log(error);
        });
    }
    else {
      Swal.fire({
        icon: 'info',
        title: 'AK Herbal',
        text: 'Your KYC is Verified. Please contact admin for change or genrate ticket for change.'
      });
    }
  }
  const handlePass = (e) => {
    e.preventDefault()
    if (newp !== rnew && newp.length < 6) {
      Swal.fire({
        icon: 'warning',
        title: 'AK Herbal',
        text: 'Please Enter valid Password'
      });
    }
    let data = JSON.stringify({
      "ip": ipAddress,
      "ulid": loginData.ulid,
      "opass": oldp,
      "npass": newp,
      "rpass": rnew
    });

    let axiosConfig = {
      method: 'post',
      maxBodyLength: Infinity,
      url: `${config.baseUrl}cpass`,
      headers: {
        'ip': ipAddress,
        'ulid': loginData.ulid,
        'auth': loginData.auth,
        'token': loginData.token,
        'Content-Type': 'application/json'
      },
      data: data
    };
    // console.log(axiosConfig)
    axios.request(axiosConfig)
      .then((response) => {
        console.log(response);
        if (response.status) {
          Swal.fire({
            icon: 'info',
            title: 'AK Herbal',
            text: response.data.message
          });
          document.getElementById("opass").value = "";
          document.getElementById("np").value = "";
          document.getElementById("rnp").value = "";
          setOld('')
          setNew('')
          setRnew('')
        }
        else {
          Swal.fire({
            icon: 'warning',
            title: 'AK Herbal',
            text: response.message
          });
        }

      })
      .catch((error) => {
        console.log(error);
      });
  }

  const getBase64 = file => {
    return new Promise(resolve => {
      //let fileInfo;
      let baseURL = "";
      // Make new FileReader
      let reader = new FileReader();

      // Convert the file to base64 text
      reader.readAsDataURL(file);

      // on reader load somthing...
      reader.onload = () => {
        // Make a fileInfo Object
        //console.log("Called", reader);
        baseURL = reader.result;
        //console.log(baseURL);
        resolve(baseURL);
      };
      //console.log(fileInfo);
    });
  };
  return (
    <>
      <div className="layout-container">
        <Menu />
        <div className="layout-page">
          <Header />
          <div className="content-wrapper">
            <div className="container-xxl flex-grow-1 container-p-y">
              <div className="row">
                <div className='col-md-12'>
                  <div className="card mb-4">
                    <h5 className="card-header text-center text-black">Your Profile</h5>
                    <div className="card-body">
                      <form id="formAccountSettings" onSubmit={handleProfileEdit} className="fv-plugins-bootstrap5 fv-plugins-framework" noValidate="novalidate">
                        <div className="row">
                          <div className="mb-2 col-sm-6 fv-plugins-icon-container">
                            <label htmlFor="name" className="form-label">Full Name</label>
                            <input type="text" id="name" name="name" className="form-control" placeholder="Your Name" value={name} onChange={(e) => { setName(e.target.value) }} />
                            <div className="fv-plugins-message-container invalid-feedback" />
                          </div>
                          <div className="mb-2 col-sm-6 fv-plugins-icon-container">
                            <label htmlFor="billingEmail" className="form-label">Email</label>
                            <input className="form-control" type="text" id="email" name="email" placeholder="Email ID" value={email} onChange={(e) => { setEmail(e.target.value) }} />
                            <div className="fv-plugins-message-container invalid-feedback" />
                          </div>
                          <div className="mb-2 col-sm-6">
                            <label htmlFor="mobile" className="form-label">Contact Number</label>
                            <input className="form-control" type="text" id="mobile" name="mobile" placeholder="Contact Number" value={mobile} onChange={(e) => { setMobile(e.target.value) }} />
                          </div>

                        </div>
                        <div className='row'>
                          <div className="mb-2 col-sm-6">
                            <label htmlFor="pan" className="form-label">Pan Number</label>
                            <input className="form-control" type="text" id="pan" name="pan" placeholder="Pan Number" value={pan} onChange={(e) => { setPan(e.target.value) }} />
                          </div>
                          <div className="mb-3 col-sm-6">
                            <label htmlFor="e1mail" className="form-label">Select Pan Image</label>
                            <input type='file' className='form-controle rounded-pill' accept="image/*" id="pani" name="pani" onChange={event => getBase64(event.target.files[0]).then(file => setpani(file))} />
                          </div>
                          <div className="mb-3 text-center col-sm-6">

                            {(pani) ? <>
                              <img src={pani} width={'200px'} />
                            </> : <>
                              <img src={pani2} width={'200px'} />
                            </>}


                          </div>
                        </div>
                        <div className='row'>
                          <div className="mb-2 col-sm-6">
                            <label htmlFor="pan" className="form-label">Addhar Number</label>
                            <input className="form-control" type="text" id="addhar" name="addhar" placeholder="Addhar Number" value={addhar} onChange={(e) => { setaddhar(e.target.value) }} />
                          </div>
                          <div className="mb-3 col-sm-6">
                            <label htmlFor="e1mail" className="form-label">Select Addhar Image</label>
                            <input type='file' className='form-controle rounded-pill' accept="image/*" id="addhari" name="addhari" onChange={event => getBase64(event.target.files[0]).then(file => setaddhari(file))} />
                          </div>
                          <div className="mb-3 text-center col-sm-6">
                            {(addhari) ? <>
                              <img src={addhari} width={'200px'} />
                            </> : <>
                              <img src={addhari2} width={'200px'} />
                            </>}
                          </div>
                        </div>
                        <div className='row'>
                          <div className="mb-2 col-sm-6">
                            <label htmlFor="bname" className="form-label">Bank Name</label>
                            <input className="form-control" type="text" id="bname" name="bname" placeholder="Bank Name" value={bname} onChange={(e) => { setBname(e.target.value) }} />
                          </div>
                          <div className="mb-2 col-sm-6">
                            <label htmlFor="ifsc" className="form-label">Bank IFSC Code</label>
                            <input className="form-control" type="text" id="ifsc" name="ifsc" placeholder="Bank IFSC Code" value={ifsc} onChange={(e) => { setifsc(e.target.value) }} />
                          </div>
                          <div className="mb-2 col-sm-6">
                            <label htmlFor="acno" className="form-label">Bank Account Number</label>
                            <input className="form-control" type="text" id="acno" name="acno" placeholder="Bank Account Number" value={acno} onChange={(e) => { setAcno(e.target.value) }} />
                          </div>
                          <div className="mb-3 col-sm-6">
                            <label htmlFor="e1mail" className="form-label">Select Bank Image</label>
                            <input type='file' className='form-controle rounded-pill' accept="image/*" id="banki" name="banki" onChange={event => getBase64(event.target.files[0]).then(file => setbanki(file))} />
                          </div>
                          <div className="mb-3 text-center col-sm-6">
                            {(banki) ? <>
                              <img src={banki} width={'200px'} />
                            </> : <>
                              <img src={banki2} width={'200px'} />
                            </>}
                          </div>
                        </div>
                        <div className='row'>
                          <div className="mb-2 col-sm-6">
                            <label htmlFor="upi" className="form-label">UPI  ID</label>
                            <input className="form-control" type="text" id="upi" name="upi" placeholder="UPI  ID" value={upi} onChange={(e) => { setUpi(e.target.value) }} />
                          </div>
                          <div className="mb-2 col-sm-6">
                            <label htmlFor="upi" className="form-label">Address</label>
                            <input className="form-control" type="text" id="address" name="address" placeholder="Address" value={address} onChange={(e) => { setaddress(e.target.value) }} />
                          </div>
                          <div className="mb-2 col-sm-6">
                            <label htmlFor="upi" className="form-label">City</label>
                            <input className="form-control" type="text" id="city" name="city" placeholder="Enter City" value={city} onChange={(e) => { setcity(e.target.value) }} />
                          </div>
                          <div className="mb-2 col-sm-6">
                            <label htmlFor="upi" className="form-label">State</label>
                            <input className="form-control" type="text" id="state" name="state" placeholder="Enter State" value={state} onChange={(e) => { setstate(e.target.value) }} />
                          </div>
                          <div className="mb-2 col-sm-6">
                            <label htmlFor="upi" className="form-label">Pin Code</label>
                            <input className="form-control" type="text" id="pin" name="pin" placeholder="Enter State" value={pin} onChange={(e) => { setpin(e.target.value) }} />
                          </div>
                        </div>
                        <div className="mt-2 text-center">
                          <button type="submit" className="btn me-2 text-sm btn-secondary">Update changes</button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
                <div className='col-md-12'>
                  <div className="card mb-4">
                    <h5 className="card-header text-center text-black">Update Password</h5>
                    <div className="card-body">
                      <form id="formAccountSettings2" onSubmit={handlePass} className="fv-plugins-bootstrap5 fv-plugins-framework" noValidate="novalidate">
                        <div className="row">
                          <div className="mb-2 col-sm-6 fv-plugins-icon-container">
                            <label htmlFor="opass" className="form-label">Old Password</label>
                            <input type="text" id="opass" name="companyName" className="form-control" placeholder="Old Passowd" onChange={(e) => { setOld(e.target.value) }} />
                            <div className="fv-plugins-message-container invalid-feedback" />
                          </div>
                          <div className="mb-2 col-sm-6 fv-plugins-icon-container">
                            <label htmlFor="billingnpl" className="form-label">New Password</label>
                            <input className="form-control" type="text" id="np" name="np" placeholder="Enter New Password" onChange={(e) => { setNew(e.target.value) }} />
                            <div className="fv-plugins-message-container invalid-feedback" />
                          </div>
                          <div className="mb-2 col-sm-6 fv-plugins-icon-container">
                            <label htmlFor="billingenp" className="form-label">Re-enter New Password</label>
                            <input className="form-control" type="password" id="rnp" placeholder="Re-Enter New Password" onChange={(e) => { setRnew(e.target.value) }} />
                            <div className="fv-plugins-message-container invalid-feedback" />
                          </div>

                        </div>
                        <div className="mt-2 text-center">
                          <button type="submit" className="btn btn-secondary me-2 text-sm">Update Password</button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>

            </div>
            <Footer />
          </div>
        </div>
      </div>
    </>
  );
}